import React, { createContext, useContext, useMemo } from "react";

const SamplingGraphExportContext = createContext(null);

/**
 * Lets graphViewV2 Plotly charts register `Plotly.toImage` for PDF export.
 * Wrap the `graphRef` container so mounted charts can call `useSamplingPlotExportRegister`.
 */
export function SamplingGraphExportProvider({ exportRef, children }) {
  const value = useMemo(
    () => ({
      register(api) {
        exportRef.current = api;
      },
      unregister() {
        exportRef.current = null;
      },
    }),
    [exportRef]
  );
  return (
    <SamplingGraphExportContext.Provider value={value}>
      {children}
    </SamplingGraphExportContext.Provider>
  );
}

export function useSamplingGraphExport() {
  return useContext(SamplingGraphExportContext);
}
